import { apiFetch } from '@/api/client'

export type GlobalLockResponse = {
  ok: true
  globalLock: boolean
  message: string
}

export type SingleMemberLockResponse = {
  ok: true
  memberId: string
  globalLock: boolean
  message: string
}

/** Lab Member/globalLock — Agent-API `POST /v1/agents/global-lock`. */
export function postGlobalLock(): Promise<GlobalLockResponse> {
  return apiFetch<GlobalLockResponse>('/v1/agents/global-lock', {
    method: 'POST',
    body: JSON.stringify({}),
  })
}

/** Lab Member/singleMemberLock — except/re-lock one account under book lock. */
export function postSingleMemberLock(memberId: string): Promise<SingleMemberLockResponse> {
  return apiFetch<SingleMemberLockResponse>('/v1/agents/single-member-lock', {
    method: 'POST',
    body: JSON.stringify({ memberId }),
  })
}
